import { Takeover } from '@/takeover';
import RetailerOffer from '@/interfaces/RetailerOffer';
import { MxrConfig } from '@/interfaces/MxrConfig';

export type GetPromotionsPayload = {
	takeover: Takeover;
	fulfillmentStoreId: string;
};
export type FetchMxrRetailerOffersPayload = {
	takeover: Takeover;
	fulfillmentStoreId: string;
};
export type FetchMxrRetailerLocationsPaylod = {
	zip: string;
	max: number;
	takeover: Takeover;
	host: string;
};
export type FetchIntegratedRetailerLocationsPaylod = {
	zip: string;
	max: number;
	promotion: MxrConfig;
	takeover: Takeover;
	host: string;
};
export type SetMxrRetailerOffersPayload = {
	offers: RetailerOffer[];
	fulfillmentStoreId: string;
};

// Actions, Mutations
export const CLOSE_SWAP_MODAL = 'closeSwapModal' as const;
export const FETCH_MXR_RETAILER_LOCATIONS =
	'fetchMxrRetailerLocations' as const;
export const NEXT_CARD = 'nextCard' as const;
export const OPEN_MXR_SWAP_MODAL = 'openMxrSwapModal' as const;
export const PREV_CARD = 'prevCard' as const;
export const SELECT_CARD = 'selectCard' as const;
export const SELECT_TAB = 'selectTab' as const;
export const SET_ACTIVE_CARD = 'setActiveCard' as const;
export const SET_BETA = 'setBeta' as const;
export const SET_CAROUSEL_PROMOTIONS = 'setCarouselPromotions' as const;
export const SET_CURRENT_MXR_RETAILER_INDEX =
	'setCurrentMxrRetailerIndex' as const;
export const SET_FULFILLMENT_STORE = 'setFulfillmentStore' as const;
export const SET_GO_TO_CART_OPEN = 'setGoToCartOpen' as const;
export const SET_INTEGRATED_RETAILER_LOCATIONS =
	'setIntegratedRetailerLocations' as const;
export const SET_IS_DEFAULT = 'setIsDefault' as const;
export const SET_KROGER_AUTH_CONFIG = 'setKrogerAuthConfig' as const;
export const SET_LOADING_PROMOTIONS = 'setLoadingPromotions' as const;
export const SET_MERCURY_LOCATION_RESULT = 'setMercuryLocationResult' as const;
export const SET_MXR_CONFIG = 'setMXRConfig' as const;
export const SET_MXR_JSON_DATA = 'setMxrJsonData' as const;
export const SET_MXR_PROMOTIONS = 'setMxrPromotions' as const;
export const SET_MXR_RETAILER = 'setMxrRetailer' as const;
export const SET_MXR_RETAILER_LOCATIONS = 'setMxrRetailerLocations' as const;
export const SET_MXR_RETAILER_OFFERS = 'setMxrRetailerOffers' as const; // as const clashing with string type in src/store/plugins/productSection.ts' mutation.type
export const SET_PROMOTION_CAROUSELS = 'setPromotionCarousels' as const;
export const SET_RETAILER = 'setRetailer' as const;
export const SET_SELECTED_SWAP = 'setSelectedSwap' as const;
export const SET_TAKEOVER = 'setTakeover' as const;
export const SET_WALMART_ITEMS = 'setWalmartItems' as const;
export const TOGGLE_RETAILER_LOCATIONS_MODAL =
	'toggleRetailerLocationsModal' as const;
export const UPDATE_PRODUCT_SHOPPING_LIST_ITEM =
	'updateProductShoppingListItem' as const;
export const UPDATE_PRODUCT_SHOPPING_LIST_SECTIONS =
	'updateProductShoppingListSections' as const;
export const UPDATE_SWAP_OPTIONS = 'updateSwapOptions' as const;
export const SET_MXR_OFFERS = 'setMxrOffers' as const;
export const UPDATE_VISIBLE_INGREDIENTS = 'updateVisibleIngredients' as const;
export const UPDATE_VISIBLE_PROMOTION_IDS =
	'updateVisiblePromotionIds' as const; // as const clashing with string type in src/store/plugins/productSection.ts' mutation.type
export const SET_TRACKING_CONFIGS = 'setTrackingConfigs' as const;
export const UPDATE_BASE_REPORTING_PARAMS =
	'updateBaseReportingParams' as const;
export const SEND_REPORT = 'sendReport' as const;
export const SET_CHECKOUT_TOTAL = 'setCheckoutTotal' as const;
export const SET_SELECTED_TAB_INDEX = 'setSelectedTabIndex' as const;
export const SET_PREVIOUS_PROMOTION = 'setPreviousPromotion' as const;
export const SET_OFFERS_COUNT_IN_CART = 'setOffersCountInCart' as const;

// Getters
export const GET_GAM_SM_PARAMS = 'getGamSMParams' as const;
export const GET_ACTIVE_CARD_INDEX = 'getActiveCardIndex' as const;
export const GET_ACTIVE_CARD_POSITION = 'getActiveardPosition' as const;
export const GET_PREVIOUS_CARD_INDEX = 'getPreviousCardIndex' as const;
export const GET_ALL_BASE_INGREDIENTS = 'getAllBaseIngredients' as const;
export const GET_BASE_INGREDIENTS = 'getBaseIngredients' as const;
export const GET_BASE_INGREDIENTS_BY_SHOPPING_LIST_ID =
	'GET_BASE_INGREDIENTS_BY_SHOPPING_LIST_ID' as const;
export const GET_BASE_INGREDIENTS_PROMOTIONS =
	'GET_BASE_INGREDIENTS_PROMOTIONS' as const;
export const GET_BASE_INGREDIENTS_PROMOTIONS_AND_MAX_OFFERS =
	'GET_BASE_INGREDIENTS_PROMOTIONS_AND_MAX_OFFERS' as const;
export const GET_BUMP_ANIMATION = 'getBumpAnimation' as const;
export const GET_CARDS = 'getCards' as const;
export const GET_CAROUSEL_BASE_INGREDIENTS =
	'getCarouselBaseIngredients' as const;
export const GET_CARD_BASE_INGREDIENTS_AND_MAX_OFFERS =
	'getCardBaseIngredientsAndMaxOffers' as const;
export const GET_ALL_BASE_INGREDIENTS_AND_MAX_OFFERS =
	'getAllBaseIngredientsAndMaxOffers' as const;
export const GET_CURRENT_CARD = 'getCurrentCard' as const;
export const GET_CURRENT_MXR_RETAILER = 'getCurrentMxrRetailer' as const;
export const GET_CUSTOM_FOOTER_ENABLED = 'getCustomFooterEnabled' as const;
export const GET_CUSTOM_FOOTER_TEXT = 'getCustomFooterText' as const;
export const GET_FOOTER_CTA = 'getFooterCTA' as const;
export const GET_FULFILLMENT_STORE = 'getFulfillmentStore' as const;
export const GET_GO_TO_CART_OPEN = 'getGoToCartOpen' as const;
export const GET_INTEGRATED_RETAILER = 'getIntegratedRetailer' as const;
export const GET_IS_BETA = 'getIsBeta' as const;
export const GET_IS_DEFAULT = 'getIsDefault' as const;
export const GET_IS_TAKEOVER = 'getIsTakeover' as const;
export const GET_ITEM_ID_BASE_INGREDIENT_MAP =
	'getItemIdBaseIngredientMap' as const;
export const GET_ITEM_ID_OFFERS_COUNT = 'getItemIdOffersCount' as const;
export const GET_KROGER_AUTH_CONFIG = 'getKrogerAuthConfig' as const;
export const GET_LOADING_PROMOTIONS = 'getLoadingPromotions' as const;
export const GET_MAX_OFFERS = 'getMaxOffers' as const;
export const GET_MERCURY_LOCATION_RESULT = 'getMercuryLocationResult' as const;
export const GET_MXR_CONFIG = 'getMXRConfig' as const;
export const GET_MXR_CONFIG_URL = 'getMXRConfigUrl' as const;
export const GET_MXR_ID = 'getMxrId' as const;
export const GET_MXR_JSON_DATA = 'getMxrJSONData' as const;
export const GET_MXR_RETAILER_LOCATIONS = 'getMxrRetailerLocations' as const;
export const GET_MXR_TYPE = 'getMxrType' as const;
export const GET_PARTNER = 'getPartner' as const;
export const GET_PRODUCT_SHOPPING_LIST_SECTIONS =
	'getProductShoppingListSections' as const;
export const GET_PROMOTIONS = 'getPromotions' as const;
export const GET_RANDOMIZE_CARDS_DISPLAYED =
	'getRandomizeCardsDisplayed' as const;
export const GET_RANDOMIZE_OFFERS_DISPLAYED =
	'getRandomizeOffersDisplayed' as const;
export const GET_RETAILER = 'getRetailer' as const;
export const GET_RETAILER_LOCATIONS_MODAL_OPEN =
	'getRetailerLocationsModalOpen' as const;
export const GET_RETAILER_OFFERS = 'getRetailerOffers' as const;
export const GET_SELECTED_OFFER_IDS = 'getSelectedOfferIds' as const;
export const GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS =
	'getSelectedProductShoppingListItems' as const;
export const GET_SELECTED_RECIPE_ID = 'getSelectedRecipeId' as const;
export const GET_SELECTED_SWAP = 'getSelectedSwap' as const;
export const GET_SELECTED_TAB = 'getSelectedTab' as const;
export const GET_SELECTED_TAB_INDEX = 'getSelectedTabIndex' as const;
export const GET_SESSION_ID = 'getSessionId' as const;
export const GET_SHOPPING_LIST = 'getShoppingList' as const;
export const GET_SHOW_CHECKOUT_TOTAL = 'getShowCheckoutTotal' as const;
export const GET_SHOW_SHOPPING_LIST_CHECKBOXES =
	'getShowShoppingListCheckboxes' as const;
export const GET_SIZE = 'getSize' as const;
export const GET_STORE_PICKER_ENABLED = 'getStorePickerEnabled' as const;
export const GET_SWAP_ENABLED = 'getSwapEnabled' as const;
export const GET_SWAP_OPEN = 'getSwapOpen' as const;
export const GET_SWAP_OPTIONS = 'getSwapOptions' as const;
export const GET_TABS = 'getTabs' as const;
export const GET_TAB_CTA = 'getTabCTA' as const;
export const GET_TAKEOVER = 'getTakeover' as const;
export const GET_THEME = 'getTheme' as const;
export const GET_VISIBLE_PROMOTIONS = 'getVisiblePromotions' as const;
export const GET_VISIBLE_PROMOTION_STRING =
	'getVisiblePromotionString' as const;
export const GET_VISIBLE_PROMOTION_UNIQUE_IDS =
	'getVisiblePromotionUniqueIds' as const;
export const GET_REPORTERS = 'getReporters' as const;
export const GET_REPORT_QUEUE = 'getReportQueue' as const;
export const GET_CHECKOUT_TOTAL = 'getCheckoutTotal' as const;
export const GET_OFFERS_COUNT_IN_CART = 'getOffersCountInCart' as const;
export const GET_PREVIOUS_PROMOTION = 'getPreviousPromotion' as const;

export const GET_CARD_CLICK_REPORT = 'getCardClickedReport' as const;
export const GET_TAB_CLICK_REPORT = 'getTabClickedReport' as const;
export const GET_CAROUSEL_CLICK_REPORT = 'getCarouselClickedReport' as const;
export const GET_THIRD_TAB_CLICK_REPORT = 'getThirdTabClickedReport' as const;
export const GET_KROGER_CHECKOUT_CLICK_REPORT =
	'getKrogerCheckoutClickedReport' as const;
export const GET_MXR_IMPRESSION_REPORT = 'getMxrImpressionReport' as const;
export const GET_MXR_VIEWED_REPORT = 'getViewedImpressionReport' as const;
export const GET_FOOTER_BUTTON_CLICKED_REPORT =
	'getFooterButtonClickedReport' as const;
export const GET_LOCATION_CLICKED_REPORT = 'getLocationClickedReport' as const;
export const GET_DESELECT_CLICKED_REPORT = 'getDeselectClickedReport' as const;
export const GET_SELECT_CLICKED_REPORT = 'getSelectClickedReport' as const;
export const GET_SWAP_CLICKED_REPORT = 'getSwapClickedReport' as const;
export const GET_REPORT_BASE_PARAMS = 'getReportBaseParams' as const;
export const GET_MXR_KROGER_CHECKOUT_REPORT =
	'getMxrKrogerCheckoutReport' as const;
export const GET_PREVIOUS_PROMOTION_FOR_REPORT =
	'getPreviousPromotionForReport' as const;

export const GET_CARTING_URL = 'getCartingUrl' as const;
